import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Power } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";

const KEY = "po_avail_reminder_shown";

// Once per browser session: approved provider who is unavailable gets a reminder.
export default function AvailabilityReminder() {
  const { user, refresh } = useAuth();
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const p = user?.provider;
  const eligible = !!user && !user.must_change_password && p?.status === "approved" && !p.available && pathname !== "/trocar-senha";
  useEffect(() => {
    if (eligible && !sessionStorage.getItem(KEY + user.id)) {
      sessionStorage.setItem(KEY + user.id, "1");
      setOpen(true);
    }
  }, [eligible, user?.id]);
  const activate = async () => {
    setBusy(true);
    try {
      await api.post("/provider/availability", { available: true });
      await refresh();
      toast.success("Você está disponível!");
      setOpen(false);
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-md rounded-3xl" data-testid="availability-reminder">
        <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-orange-100 text-orange-600"><Power className="h-9 w-9" /></span>
        <DialogTitle className="text-center font-display text-2xl font-extrabold">Você está indisponível</DialogTitle>
        <DialogDescription className="text-center text-lg text-slate-700">
          Lembre-se de ativar o seu botão Disponível para aparecer no mapa e receber pedidos.
        </DialogDescription>
        <div className="mt-2 grid gap-3">
          <button onClick={activate} disabled={busy} className="po-btn-primary min-h-[60px] text-lg" data-testid="availability-reminder-activate">
            {busy ? "Ativando..." : "Ativar agora"}
          </button>
          <button onClick={() => setOpen(false)} className="po-btn-outline min-h-[52px] text-lg" data-testid="availability-reminder-later">Depois</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
